function mapEvent(mapType, options, history, dashboardType, toggleEnabled) {
  let stateDash = dashboardType + 'StateDashboard'
  let msaDash = dashboardType + 'MSADashboard'
  let hash = undefined
  if (mapType !== undefined && mapType === 'CIACCURACY') {
    if ('state' in options) {
      hash = `state-${options.state}`
      history.push({ hash: hash })
    } else if ('cbsa' in options) {
      hash = `msa-${options.cbsa}`
      history.push({ hash: hash })
    }
  } else if (
    (mapType !== undefined && mapType === 'FLUMAP') ||
    (mapType !== undefined && mapType === 'ZIP3MAP')
  ) {
    if ('state' in options && options.parent.toLowerCase() === 'us') {
      if (toggleEnabled) {
        window.location.href = `/FluStateDashboard/STATE/${options.state}`
      } else {
        hash = `state-${options.state}`
        history.push({ hash: hash })
      }
    } else if ('cbsa' in options && dashboardType === 'metro') {
      if (toggleEnabled) {
        window.location.href = `/FluMSADashboard/${options.parent}/MSA/${options.cbsa}`
      } else {
        hash = `metro-${options.cbsa}`
        history.push({ hash: hash })
      }
    } else if ('zip3' in options && dashboardType === 'zip3') {
      if (toggleEnabled) {
        window.location.href = `/FLUZIP3Dashboard/${options.parent}/ZIP3/${options.zip3}`
      } else {
        hash = `zip3-${options.zip3}-${options.parent}`
        history.push({ hash: hash })
      }
    } else if ('geo_id' in options && dashboardType === 'ALLERGIES') {      
        window.location.href = `/AllergiesZip3Dashboard/${options.geo_parent}/ZIP3/${options.geo_id}`      
    }
  } else if (mapType !== undefined && mapType === 'VUL') {
    // console.log(options.projected_Pct)
    if ('state' in options) {
      if (options.projected_Pct === 0 || options.projected_Pct === undefined) {
      } else {
        hash = `state-${options.stateId}`
        history.push({ hash: hash })
      }
    }
  } else if (mapType !== undefined && mapType === 'COVERAGEMAP') {
  } else if (
    mapType !== undefined &&
    mapType === 'RSVMAP' &&
    'state' in options
  ) {
    if (dashboardType === 'ALLERGIES')
      window.location.href = `/AllergiesStateDashboard/state/${options.state}`
    else {
      hash = `/forecasts/${stateDash}/STATE/${options.state}`
      history.push(hash)
    }
  } else if (
    mapType === 'RSVMAPMSA' &&
    'state' in options &&
    options.geo_parent !== 'US'
  ) {
    hash = `/forecasts/${msaDash}/${options.geo_parent.split(',')[0]}/MSA/${options.state}`
    history.push(hash)
  } else if (
    mapType === 'RSVMAPMSA' &&
    'state' in options &&
    options.geo_parent === 'US'
  ) {
    window.location.href = `/forecasts/${stateDash}/STATE/${options.state}`
  } else if (
    mapType === 'RSVMAPCDO' &&
    'state' in options &&
    options.geo_parent !== 'US'
  ) {
    window.location.href = `/${msaDash}/${options.geo_parent.split(',')[0]}/MSA/${options.state}`
  } else if (
    mapType === 'RSVMAPCDO' &&
    'state' in options &&
    options.geo_parent === 'US'
  ) {
    window.location.href = `/${stateDash}/STATE/${options.state}`
  } else if (
    mapType !== undefined &&
    mapType === 'COVIDMAP' &&
    'state' in options
  ) {
    hash = `/forecasts/${stateDash}/STATE/${options.state}`
    history.push(hash)
  } else if (
    mapType !== undefined &&
    mapType === 'COVIDMAPMSA' &&
    'state' in options &&
    options.geo_parent === 'US'
  ) {
    window.location.href = `/forecasts/${stateDash}/STATE/${options.state}`
  } else if (
    mapType !== undefined &&
    mapType === 'ZIP3MAP' &&
    dashboardType === 'ALLERGIES' &&
    'state' in options &&
    options.geo_parent === 'US'
  ) {
    window.location.href = `/AllergiesZip3Dashboard/${options.state}/zip3/`
  } else if (
    mapType !== undefined &&
    mapType === 'COVIDMAPMSA' &&
    'state' in options &&
    options.geo_parent !== 'US'
  ) {
    hash = `/forecasts/${msaDash}/${options.geo_parent.split(',')[0]}/MSA/${options.state}`
    history.push(hash)
  }
}

export default mapEvent
